import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/store";

export type CategoriesReducerState = {
  search: Nullable<string>;
};

const initialState: CategoriesReducerState = {
  search: null,
};

const knowledgebaseNgCategoriesSlice = createSlice({
  name: "knowledgebaseNg/categories",
  initialState,
  reducers: {
    setSearch(state, { payload }: PayloadAction<Nullable<string>>) {
      state.search = payload;
    },

    resetFilters(state) {
      state.search = null;
    },
  },
});

export const { setSearch, resetFilters } = knowledgebaseNgCategoriesSlice.actions;
export const categoriesSelector = (state: RootState) => state.knowledgebaseNg.categories;
export default knowledgebaseNgCategoriesSlice.reducer;
